/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { Link } from "react-router-dom";
export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  {
    editItem,
    deleteItem,
    disableDeleteItem,
    downloadItem,
    multistatus,
    settingItem,
    settingPermission,
    settingScrim,
    typeRedirect,
    viewItem,
    viewItemwithname,
    viewItem2,
    statusChange,
    approveStatus,
    rejectStatus,
    inactiveStatus,
    sponsorAd,
    audituserLink,
    auditViewItem,
    disableEditItem,
    youtubeItem,
    instagramItem,
    addpageItem,
    loadItem,
    viewContest,
    viewUserProfile,
    viewUserProfileid,
    viewContestSingle,
    extraPlayerHackingCounter,
    approvedTeamItem,
    rejectTeamItem,
  }
) => (
  <>
    {editItem && (
      <OverlayTrigger
        overlay={<Tooltip id="products-edit-tooltip">Edit Item</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-primary btn-sm mx-1"
          onClick={() => {
            row._id ? editItem(row._id) : editItem(row.sku);
          }}
        >
          <span className="svg-icon svg-icon-md svg-icon-primary">
            <SVG
              src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
            />
          </span>
        </a>
      </OverlayTrigger>
    )}

    {addpageItem && row.isAddCompleted===false  && (
       <OverlayTrigger
       overlay={<Tooltip id="products-edit-tooltip">Edit KPI's</Tooltip>}
     >
       <a
         className="btn btn-icon btn-light btn-hover-primary btn-sm mx-1"
         onClick={() => {
          //  console.log("addpageItem*************", row);
           row._id ? addpageItem(row._id, row.fullName) : addpageItem(row.sku, row.fullName);
         }}
       >
         <span className="svg-icon svg-icon-success">
           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
             <path d="M19 3H6C4.34315 3 3 4.34315 3 6V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V8L16 3H19Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
             <path d="M12 8V16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
             <path d="M8 12H16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
           </svg>
         </span>
       </a>
     </OverlayTrigger>
    )}
     {disableDeleteItem && (
          row.numberOfCouponsUsed > 0 ? 
           
            <span
              className={`btn btn-icon btn-light btn-sm mx-1 ${
                row.numberOfCouponsUsed > 0 ? 'disabled' : 'btn-hover-danger'
              }`}
              onClick={row.numberOfCouponsUsed === 0 ? () => disableDeleteItem(row) : null}
              style={{ cursor: row.numberOfCouponsUsed === 0 ? 'pointer' : 'not-allowed' }}
            >
              <span className="svg-icon svg-icon-md svg-icon-danger">
                <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
              </span>
            </span>
          :
          <OverlayTrigger
            overlay={
          
          <Tooltip id="products-delete-tooltip">
            {row.numberOfCouponsUsed > 0 ? "" : "Delete Item"}
          </Tooltip>
        }
      >
        <span
          className={`btn btn-icon btn-light btn-sm mx-1 ${
            row.numberOfCouponsUsed > 0 ? 'disabled' : 'btn-hover-danger'
          }`}
          onClick={row.numberOfCouponsUsed === 0 ? () => disableDeleteItem(row) : null}
          style={{ cursor: row.numberOfCouponsUsed === 0 ? 'pointer' : 'not-allowed' }}
        >
          <span className="svg-icon svg-icon-md svg-icon-danger">
            <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
          </span>
        </span>
      </OverlayTrigger>
    )}
    {disableEditItem && (
      <OverlayTrigger
        overlay={<Tooltip id="products-edit-tooltip">Edit Item</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-primary btn-sm mx-1"
          onClick={() => editItem(row._id)}
          style={{ pointerEvents: "none" }}
        >
          <span className="svg-icon svg-icon-md svg-icon-primary">
            <SVG
              src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
            />
          </span>
        </a>
      </OverlayTrigger>
    )}
    {audituserLink && (
      <a className="btn-link" onClick={() => audituserLink(row)}>
        <span className="svg-icon svg-icon-md svg-icon-primary">
          {row._id && row._id.user && row._id.user.name}
        </span>
      </a>
    )}
    {multistatus && (
      <OverlayTrigger
        overlay={<Tooltip id="products-edit-tooltip">Status</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-primary btn-sm"
          onClick={() => multistatus(row._id)}
        >
          <span style={{ width: "153px" }}>
            <span
              className={`label label-lg font-weight-bold label-inline ${
                row.status === "inProgress"
                  ? "label-light-primary"
                  : row.status === "completed"
                  ? "label-light-info"
                  : row.status === "errorOccurred"
                  ? "label-light-danger"
                  : ""
              }`}
            >
              {row.status}
            </span>
          </span>
        </a>
      </OverlayTrigger>
    )}
{loadItem && (
  <OverlayTrigger
    overlay={<Tooltip id="products-edit-tooltip">Load</Tooltip>}
  >
    <a
      className="btn btn-icon btn-light btn-hover-primary btn-sm mx-1"
      onClick={() => {
        row._id ? loadItem(row._id) : loadItem(row.sku);
      }}
    >
      <span className="svg-icon svg-icon-success">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M12 4V1L8 5l4 4V6a6 6 0 0 1 6 6h-2a4 4 0 0 0-4-4zM4 12a8 8 0 1 0 8-8v2a6 6 0 1 1-6 6H4z" fill="currentColor" />
          <path d="M12 4V1L8 5l4 4V6a6 6 0 0 1 6 6h-2a4 4 0 0 0-4-4zM4 12a8 8 0 1 0 8-8v2a6 6 0 1 1-6 6H4z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>
    </a>
  </OverlayTrigger>
)}




    {
      settingItem && (
        <OverlayTrigger
          overlay={<Tooltip id="products-edit-tooltip">Setting Item</Tooltip>}
        >
          <a
            className="btn btn-icon btn-light btn-hover-primary btn-sm"
            onClick={() => settingItem(row._id)}
          >
            <span className="svg-icon svg-icon-md svg-icon-primary">
            <SVG src={toAbsoluteUrl("/media/svg/icons/General/Settings-2.svg")} />
            </span>
          </a>
        </OverlayTrigger>
      )
    }
     {
      settingPermission && (
        <OverlayTrigger
          overlay={<Tooltip id="products-edit-tooltip">Setup Permissions</Tooltip>}
        >
          <a
            className="btn btn-icon btn-light btn-hover-primary btn-sm"
            onClick={() => settingPermission(row._id)}
          >
            <span className="svg-icon svg-icon-md svg-icon-primary">
            <SVG src={toAbsoluteUrl("/media/svg/icons/General/Settings-2.svg")} />
            </span>
          </a>
        </OverlayTrigger>
      )
    }
    {
      settingScrim && (
        <OverlayTrigger
          overlay={<Tooltip id="products-edit-tooltip">Setting Item</Tooltip>}
        >
          <a
            className="btn btn-icon btn-light btn-hover-primary btn-sm"
            onClick={() => settingScrim(row._id)}
          >
            <span className="svg-icon svg-icon-md svg-icon-primary">
              Settings <SVG src={toAbsoluteUrl("/media/svg/icons/General/Settings-2.svg")} fill="black" />
            </span>
          </a>
        </OverlayTrigger>
      )
    }

    {typeRedirect && (
      <OverlayTrigger
        overlay={<Tooltip id="products-edit-tooltip">Game Types</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-primary btn-sm"
          onClick={() => typeRedirect(row._id)}
        >
          <span className="svg-icon svg-icon-md svg-icon-primary">
            <SVG
              src={toAbsoluteUrl("/media/svg/icons/General/Settings-1.svg")}
            />
          </span>
        </a>
      </OverlayTrigger>
    )}
    {deleteItem && (
      <OverlayTrigger
        overlay={<Tooltip id="products-delete-tooltip">Delete Item</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-danger btn-sm mx-1"
          onClick={() => deleteItem(row)}
        >
          <span className="svg-icon svg-icon-md svg-icon-danger">
            <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
          </span>
        </a>
      </OverlayTrigger>
    )}
    {downloadItem && (
      <OverlayTrigger
        overlay={
          <Tooltip id="products-download-tooltip">Download Item</Tooltip>
        }
      >
        <a
          className="btn btn-icon btn-light btn-hover-info btn-sm"
          onClick={() => downloadItem(row._id, row)}
        >
          <span className="svg-icon svg-icon-primary svg-icon-2x">
            <SVG src={toAbsoluteUrl("/media/svg/icons/Files/Download.svg")} />
          </span>
        </a>
      </OverlayTrigger>
    )}
  {viewItem && (
      <OverlayTrigger
        overlay={<Tooltip id="products-delete-tooltip">View Item</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-primary btn-sm mx-1"
          onClick={() => viewItem(row._id, row)}
        >
          <span className="svg-icon svg-icon-md svg-icon-primary">
            <SVG src={toAbsoluteUrl("/media/svg/icons/General/Visible.svg")} />
          </span>
        </a>
      </OverlayTrigger>
    )}

{viewItemwithname && (
  <OverlayTrigger
    overlay={<Tooltip id="products-delete-tooltip">View Item</Tooltip>}
  >
    <a
      className="btn btn-icon btn-light btn-hover-primary btn-sm mx-1"
      onClick={() => viewItemwithname(row._id, row.fullName)} // Pass only the fullName here
    >
      <span className="svg-icon svg-icon-md svg-icon-primary">
        <SVG src={toAbsoluteUrl("/media/svg/icons/General/Visible.svg")} />
      </span>
    </a>
  </OverlayTrigger>
)}

       {instagramItem && (
      <OverlayTrigger
        overlay={<Tooltip id="products-edit-tooltip">Instagram Link</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-primary btn-sm mx-1"
          onClick={() => {
            if (row.instagram) {
              window.open(row.instagram, '_blank');
            } else {
              instagramItem(row._id ? row._id : row.sku);
            }
          }}
        >


     <span class="svg-icon svg-icon-success">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <defs>
            <linearGradient id="instagram-gradient" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stop-color="#f58529"/>
                <stop offset="30%" stop-color="#dd2a7b"/>
                <stop offset="60%" stop-color="#8134af"/>
                <stop offset="100%" stop-color="#515bd4"/>
            </linearGradient>
        </defs>
        <rect x="2" y="2" width="20" height="20" rx="5" ry="5" fill="url(#instagram-gradient)"/>
        <path d="M16 11.37a4 4 0 1 1-4.63-4.63 4 4 0 0 1 4.63 4.63z" fill="white"/>
        <circle cx="17.5" cy="6.5" r="1.5" fill="white"/>
    </svg>
</span>



        </a>
      </OverlayTrigger>
    )}
   {youtubeItem && (
  <OverlayTrigger
    overlay={<Tooltip id="products-edit-tooltip">Youtube Link</Tooltip>}
  >
    <a
      className="btn btn-icon btn-light btn-hover-primary btn-sm mx-1"
      onClick={() => {
        if (row.youtube) {
          window.open(row.youtube, '_blank');
        } else {
          youtubeItem(row._id ? row._id : row.sku);
        }
      }}
    >
      <span className="svg-icon svg-icon-success">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M23.4985 6.18656C23.4385 5.94469 23.3164 5.72121 23.1431 5.53558C22.9698 5.34994 22.7512 5.20868 22.5075 5.12607C21.1943 4.67334 12 4.67334 12 4.67334C12 4.67334 2.80567 4.67334 1.49254 5.12607C1.2488 5.20868 1.03021 5.34994 0.856913 5.53558C0.683617 5.72121 0.561521 5.94469 0.501513 6.18656C0.0500627 7.4999 0.0500627 11.9999 0.0500627 11.9999C0.0500627 11.9999 0.0500627 16.4999 0.501513 17.8133C0.561521 18.0551 0.683617 18.2786 0.856913 18.4643C1.03021 18.6499 1.2488 18.7912 1.49254 18.8738C2.80567 19.3266 12 19.3266 12 19.3266C12 19.3266 21.1943 19.3266 22.5075 18.8738C22.7512 18.7912 22.9698 18.6499 23.1431 18.4643C23.3164 18.2786 23.4385 18.0551 23.4985 17.8133C23.9499 16.4999 23.9499 11.9999 23.9499 11.9999C23.9499 11.9999 23.9499 7.4999 23.4985 6.18656Z" fill="#FF0000"/>
          <path d="M9.75328 15.2472V8.75259L15.5141 12L9.75328 15.2472Z" fill="white"/>
        </svg>
      </span>
    </a>
  </OverlayTrigger>
)}

    {auditViewItem && (
      <OverlayTrigger
        overlay={<Tooltip id="products-delete-tooltip">View Item</Tooltip>}
      >
        <Link
          className="btn btn-icon btn-light btn-hover-primary btn-sm"
          to={`/contests/audit-view/${row._id}`}
          // onClick={() => viewItem(row._id, row)}
        >
          <span className="svg-icon svg-icon-md svg-icon-primary">
            <SVG src={toAbsoluteUrl("/media/svg/icons/General/Visible.svg")} />
          </span>
        </Link>
      </OverlayTrigger>
    )}
    {viewItem2 && (
      <OverlayTrigger
        overlay={<Tooltip id="products-delete-tooltip">View Item</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-primary btn-sm ml-2"
          onClick={() => viewItem2(row._id, row)}
        >
          <span className="svg-icon svg-icon-md svg-icon-primary ml-2">
            <SVG src={toAbsoluteUrl("/media/svg/icons/Files/File.svg")} />
          </span>
        </a>
      </OverlayTrigger>
    )}
    {sponsorAd && (
      <OverlayTrigger
        overlay={<Tooltip id="products-delete-tooltip">View Ads</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-primary btn-sm"
          onClick={() => sponsorAd(row._id, row)}
        >
          <span className="svg-icon svg-icon-md svg-icon-primary ml-2">
            <SVG
              src={toAbsoluteUrl("/media/svg/icons/General/Settings-1.svg")}
            />
          </span>
        </a>
      </OverlayTrigger>
    )}
    {approveStatus && row.status === "1" && (
      <OverlayTrigger
        overlay={<Tooltip id="products-delete-tooltip">Approve Status</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-primary btn-sm"
          onClick={() => approveStatus(row)}
        >
          <span className="svg-icon svg-icon-md svg-icon-primary">
            <SVG src={toAbsoluteUrl("/media/svg/icons/General/Like.svg")} />
          </span>
        </a>
      </OverlayTrigger>
    )}
    {rejectStatus && row.status === "1" && (
      <OverlayTrigger
        overlay={<Tooltip id="products-delete-tooltip">Reject Status</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-danger btn-sm ml-1"
          onClick={() => rejectStatus(row)}
        >
          <span className="svg-icon svg-icon-md svg-icon-danger">
            <SVG src={toAbsoluteUrl("/media/svg/icons/General/Dislike.svg")} />
          </span>
        </a>
      </OverlayTrigger>
    )}
    {inactiveStatus && row.status === true && (
      <OverlayTrigger
        overlay={
          <Tooltip id="products-delete-tooltip">In Active Status</Tooltip>
        }
      >
        <a
          className="btn btn-icon btn-light btn-hover-danger btn-sm ml-1"
          onClick={() => inactiveStatus(row)}
        >
          <span className="svg-icon svg-icon-md svg-icon-danger">
            <SVG src={toAbsoluteUrl("/media/svg/icons/General/Dislike.svg")} />
          </span>
        </a>
      </OverlayTrigger>
    )}
    {statusChange && (
      <OverlayTrigger
        overlay={<Tooltip id="products-delete-tooltip">Status</Tooltip>}
      >
        <span className="switch switch-primary switch-icon">
          <label>
            <input
              onChange={() => statusChange(row)}
              type="checkbox"
              checked={row.isActive}
              name="isActive"
            />
            <span></span>
          </label>
        </span>
        {/* <a
          className="btn btn-icon btn-light btn-hover-primary btn-sm"
          onClick={() => statusChange(row._id)}
        >
          <span className="svg-icon svg-icon-md svg-icon-primary">
            <SVG src={toAbsoluteUrl("/media/svg/icons/General/Visible.svg")} />
          </span>
        </a> */}
      </OverlayTrigger>
    )}

    {/* {console.log("row._id", row.contest)} */}
    {/* {viewContest && (
      <OverlayTrigger
        overlay={<Tooltip id="products-delete-tooltip">View Contest</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-primary w-100"
          onClick={() => viewContest(row._id, row)}
        >
          <span className="svg-icon svg-icon-md svg-icon-primary">
             View Contest
          </span>
        </a>
      </OverlayTrigger>
    )} */}
    {viewContest ? (
      row.contest.map((data) => (
        <OverlayTrigger
          overlay={<Tooltip id="products-delete-tooltip">View Contest</Tooltip>}
        >
          <a
            className="btn btn-dark btn-hover-primary mr-3 mb-2 view-contest-btn"
            target={"_blank"}
            onClick={() => viewContest(data.contest, data?.event || null)}
          >
            <span className="svg-icon svg-icon-md svg-icon-primary">
              View Contest
            </span>
          </a>
        </OverlayTrigger>
      ))
    ) : (
      <></>
    )}

{viewUserProfile ? (
      //row.contest.map(data =>
      <OverlayTrigger
        overlay={<Tooltip id="products-delete-tooltip">User id</Tooltip>}
      >
        <a
          // className="btn btn-dark btn-hover-primary mr-3"
          target={"_blank"}
          onClick={() => viewUserProfile(row?.user_id, row?.event || null)}
        >
          <span className="svg-icon svg-icon-md svg-icon-primary">
          {row?.user_id}
          </span>
        </a>
      </OverlayTrigger>
    ) : (
      //)
      <></>
    )}
    {viewUserProfileid ? (
      //row.contest.map(data =>
      <OverlayTrigger
        overlay={<Tooltip id="products-delete-tooltip">User id</Tooltip>}
      >
        <a
          // className="btn btn-dark btn-hover-primary mr-3"
          target={"_blank"}
          onClick={() => viewUserProfileid(row?._id, row?.event || null)}
        >
          <span className="svg-icon svg-icon-md svg-icon-primary">
          {row?._id}
          </span>
        </a>
      </OverlayTrigger>
    ) : (
      //)
      <></>
    )}
    {viewContestSingle ? (
      //row.contest.map(data =>
      <OverlayTrigger
        overlay={<Tooltip id="products-delete-tooltip">View Contest</Tooltip>}
      >
        <a
          className="btn btn-dark btn-hover-primary mr-3"
          target={"_blank"}
          onClick={() => viewContestSingle(row.contest, row?.event || null)}
        >
          <span className="svg-icon svg-icon-md svg-icon-primary">
            View Contest
          </span>
        </a>
      </OverlayTrigger>
    ) : (
      //)
      <></>
    )}

    {extraPlayerHackingCounter ? <>1</> : <></>}

    {approvedTeamItem && (
      <OverlayTrigger
        overlay={<Tooltip id="products-edit-tooltip">Approve Ream</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-primary btn-sm mx-1"
          onClick={() => approvedTeamItem(row._id)}
        >
          <svg
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xlink="http://www.w3.org/1999/xlink"
          >
            <defs></defs>
            <g
              id="Stockholm-icons-/-General-/-Like"
              stroke="none"
              strokeWidth="1"
              fill="none"
              fillRule="evenodd"
            >
              <rect id="bound" x="0" y="0" width="24" height="24"></rect>
              <path
                d="M9,10 L9,19 L10.1525987,19.3841996 C11.3761964,19.7920655 12.6575468,20 13.9473319,20 L17.5405883,20 C18.9706314,20 20.2018758,18.990621 20.4823303,17.5883484 L21.231529,13.8423552 C21.5564648,12.217676 20.5028146,10.6372006 18.8781353,10.3122648 C18.6189212,10.260422 18.353992,10.2430672 18.0902299,10.2606513 L14.5,10.5 L14.8641964,6.49383981 C14.9326895,5.74041495 14.3774427,5.07411874 13.6240179,5.00562558 C13.5827848,5.00187712 13.5414031,5 13.5,5 L13.5,5 C12.5694044,5 11.7070439,5.48826024 11.2282564,6.28623939 L9,10 Z"
                id="Path-42"
                fill="#000000"
              ></path>
              <rect
                id="Rectangle-153"
                fill="#000000"
                opacity="0.3"
                x="2"
                y="9"
                width="5"
                height="11"
                rx="1"
              ></rect>
            </g>
          </svg>
        </a>
      </OverlayTrigger>
    )}
  </>
);
